import { Component, input } from '@angular/core'
import { ChangeType } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'vc-price-history',
   templateUrl: './price-history.component.html',
   styleUrl: './price-history.component.scss',
   standalone: false,
})
export class PriceHistoryComponent {
   public priceChangeData = input<Array<any>>()
   public title = input<string>()

   getChangeTypeText(ct: ChangeType) {
      switch (ct) {
         case ChangeType.Historical:
            return 'Historical'
         case ChangeType.Manual:
            return 'Manual'
         case ChangeType.Requested:
            return 'Requested'
         case ChangeType.SystemReset:
            return 'System Reset'
         case ChangeType.SystemWriteback:
            return 'System Writeback'
         case ChangeType.AnnualPricing:
            return 'Annual Pricing'
      }
   }
}
